'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.priceButton = exports.PRICE_BUTTON = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _BOOKMAKERS, _BOOKMAKERS2;

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _DiffusionServiceUtils = require('../utils/DiffusionServiceUtils');

var _DIFFUSION = require('../constants/DIFFUSION');

var _DIFFUSION2 = _interopRequireDefault(_DIFFUSION);

var _PricesStateStore = require('../stores/PricesStateStore');

var _PricesProvider = require('../PricesProvider');

var _PreloadedStateHelper = require('../utils/PreloadedStateHelper');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var BOOKMAKERS = (_BOOKMAKERS = {
    WH_OXI: 'WH_OXI',
    '#BESTODDS': 'ui-priceBtn_bestOdds',
    LADB: 'LADB',
    BET365: 'BET365',
    CORAL: 'CORAL',
    PPWR: 'PPWR',
    BETFAIR: 'BETFAIR',
    VC: 'VC'
}, _defineProperty(_BOOKMAKERS, _PreloadedStateHelper.skybetDiffusionName, _PreloadedStateHelper.skybetDiffusionName), _defineProperty(_BOOKMAKERS, 'BOLEYSPORTS', 'BOLEYSPORTS'), _defineProperty(_BOOKMAKERS, 'TOTE', 'TOTE'), _defineProperty(_BOOKMAKERS, 'BETFRED', 'BETFRED'), _BOOKMAKERS);

var PRICE_BUTTON = exports.PRICE_BUTTON = {
    CLASSES: {
        SUBSCRIBED: 'js-PC-subscribed',
        NOT_SUBSCRIBED: '.js-diffusionHorsesList:not(.js-PC-subscribed)',
        NOT_CLICKABLE: 'noPointerClass',
        HIDDEN: 'ui-priceBtn_noPrice'
    },
    SELECTORS: {
        RACE_SETTINGS: '.js-diffusionTopicSettingsRace', // General container
        HORSE_ELEMENT: '.js-diffusionHorsesList', // Div with particular price
        PRICE_VALUE: '.js-diffusionPriceValue' // <a> with data from diffusion
    },
    POPUP: {
        HEIGHT: 'data-popup-height',
        WIDTH: 'data-popup-width',
        BLANK: 'data-popup-blank',
        LINK_CLASS: 'js-popupLink'
    },
    BOOKMAKERS: (_BOOKMAKERS2 = {}, _defineProperty(_BOOKMAKERS2, BOOKMAKERS.WH_OXI, 'ui-priceBtn_williamHill'), _defineProperty(_BOOKMAKERS2, '#BESTODDS', 'ui-priceBtn_bestOdds'), _defineProperty(_BOOKMAKERS2, BOOKMAKERS.LADB, 'ui-priceBtn_ladbrokes'), _defineProperty(_BOOKMAKERS2, BOOKMAKERS.BET365, 'ui-priceBtn_bet365'), _defineProperty(_BOOKMAKERS2, BOOKMAKERS.CORAL, 'ui-priceBtn_coral'), _defineProperty(_BOOKMAKERS2, BOOKMAKERS.PPWR, 'ui-priceBtn_paddypower'), _defineProperty(_BOOKMAKERS2, BOOKMAKERS.BETFAIR, 'ui-priceBtn_betfair'), _defineProperty(_BOOKMAKERS2, BOOKMAKERS.VC, 'ui-priceBtn_betVictor'), _defineProperty(_BOOKMAKERS2, _PreloadedStateHelper.skybetDiffusionName, 'ui-priceBtn_skybet'), _defineProperty(_BOOKMAKERS2, BOOKMAKERS.BOLEYSPORTS, 'ui-priceBtn_boylesports'), _defineProperty(_BOOKMAKERS2, BOOKMAKERS.TOTE, 'ui-priceBtn_tote'), _defineProperty(_BOOKMAKERS2, BOOKMAKERS.BETFRED, 'ui-priceBtn_betfred'), _BOOKMAKERS2)
};

/* eslint-disable no-use-before-define */
var priceButton = exports.priceButton = {
    activate: activate,
    deactivate: deactivate
};

function activate() {
    _PricesProvider.pricesProvider.subscribe(_PricesProvider.PRICE_HANDLER_EVENTS.PRICE_RECEIVED, onPriceReceived);
    _PricesProvider.pricesProvider.subscribe(_PricesProvider.PRICE_HANDLER_EVENTS.PRICES_SETTINGS_CHANGED, onPriceSettingsChanged);
    _PricesProvider.pricesProvider.subscribe(_PricesProvider.PRICE_HANDLER_EVENTS.RACE_INFO_RECEIVED, onRaceInfoReceived);
    _PricesProvider.pricesProvider.subscribe(_PricesProvider.PRICE_HANDLER_EVENTS.PRICES_WILL_BE_UPDATED, onPricesWillBeUpdated);
    addBetslipEventListeners();
}

function deactivate() {
    _PricesProvider.pricesProvider.unsubscribe(_PricesProvider.PRICE_HANDLER_EVENTS.PRICE_RECEIVED, onPriceReceived);
    _PricesProvider.pricesProvider.unsubscribe(_PricesProvider.PRICE_HANDLER_EVENTS.PRICES_SETTINGS_CHANGED, onPriceSettingsChanged);
    _PricesProvider.pricesProvider.unsubscribe(_PricesProvider.PRICE_HANDLER_EVENTS.RACE_INFO_RECEIVED, onRaceInfoReceived);
    _PricesProvider.pricesProvider.unsubscribe(_PricesProvider.PRICE_HANDLER_EVENTS.PRICES_WILL_BE_UPDATED, onPricesWillBeUpdated);
}

function onPriceReceived(renderConfig) {
    var currentBookmaker = _PricesStateStore.pricesStateStore.getCurrentBookmaker();
    if (currentBookmaker === renderConfig.bookmaker) {
        renderPrice(renderConfig);
    }
}

function onPriceSettingsChanged(_ref) {
    var showDecimal = _ref.showDecimal;

    togglePricesViewType({ showDecimal: showDecimal });
}

function onPricesWillBeUpdated() {
    clearPrices();
}

function addBetslipEventListeners() {
    document.addEventListener('BETSLIP.SELECTION_MADE', function () {
        setAddedToBetslipClass();
    });

    document.addEventListener('BETSLIP.SELECTION_REMOVED', function () {
        setAddedToBetslipClass();
    });
}

function onRaceInfoReceived(_ref2) {
    var bookmaker = _ref2.bookmaker,
        courseName = _ref2.courseName,
        raceDate = _ref2.raceDate,
        raceTime = _ref2.raceTime,
        suspendState = _ref2.suspendState;

    if (suspendState === 'H') {
        markPricesOfFinishedRaces({ bookmaker: bookmaker, courseName: courseName, raceDate: raceDate, raceTime: raceTime });
    }
}

function markPricesOfFinishedRaces(_ref3) {
    var bookmaker = _ref3.bookmaker,
        courseName = _ref3.courseName,
        raceDate = _ref3.raceDate,
        raceTime = _ref3.raceTime;

    var priceElements = (0, _jquery2.default)(PRICE_BUTTON.SELECTORS.PRICE_VALUE).toArray();
    var currentBookmaker = _PricesStateStore.pricesStateStore.getCurrentBookmaker();

    if (bookmaker !== currentBookmaker) {
        return;
    }
    priceElements.filter(function (priceElement) {
        var elementData = _DiffusionServiceUtils.diffusionServiceUtils.getElementDiffusionData(priceElement);

        return elementData.courseName === courseName && elementData.raceDate === raceDate && elementData.raceTime === raceTime;
    }).forEach(function (priceElement) {
        var element = priceElement;

        element.innerHTML = '-';
        element.classList.add(PRICE_BUTTON.CLASSES.NOT_CLICKABLE);
    });
}

function togglePricesViewType(_ref4) {
    var showDecimal = _ref4.showDecimal;

    var priceElements = (0, _jquery2.default)(PRICE_BUTTON.SELECTORS.PRICE_VALUE).toArray();

    priceElements.forEach(togglePriceViewType);

    function togglePriceViewType(priceElement) {
        var element = priceElement;
        var currentValue = priceElement.innerHTML;
        var isNoPrice = ['', '-', 'SP'].includes(currentValue);

        if (!isNoPrice) {
            element.innerHTML = showDecimal ? Math.floor(parseFloat(priceElement.getAttribute(_DIFFUSION2.default.DATA.OUTPUT.DECIMAL)) * 100) / 100 : priceElement.getAttribute(_DIFFUSION2.default.DATA.OUTPUT.FRACTIONAL);

            if (_DIFFUSION2.default.DATA.INPUT.BOOKMAKER === 'TOTE') {
                element.innerHTML = parseFloat(element.innerHTML).toFixed(2);
            }
        }
    }
}

function renderPrice(renderConfig) {
    var priceElements = _DiffusionServiceUtils.diffusionServiceUtils.getPriceContainer(renderConfig);

    priceElements.forEach(function (buttonContainer) {
        var priceElement = (0, _jquery2.default)(buttonContainer).find(PRICE_BUTTON.SELECTORS.PRICE_VALUE)[0];
        var $priceElement = (0, _jquery2.default)(priceElement);
        var renderPriceValue = _DiffusionServiceUtils.diffusionServiceUtils.getDisplayedPriceValue(renderConfig);

        if (priceElement) {
            applyButtonStyling($priceElement, renderPriceValue, renderConfig.bookmaker);

            setDiffusionDataAttributes($priceElement, _extends(renderConfig, { nextPrice: renderPriceValue }));
            $priceElement.text(renderPriceValue);
        }
    });

    setAddedToBetslipClass();
}

function clearPrices() {
    (0, _jquery2.default)(PRICE_BUTTON.SELECTORS.PRICE_VALUE).toArray().forEach(function (priceElement) {
        var element = priceElement;

        element.innerHTML = '';
        setDiffusionDataAttributes(element, {});
        clearBookmakerStyling(element);
    });
}

function setAddedToBetslipClass() {
    var nextSelections = !!window.betslipApi && window.betslipApi.getSelectedBets();
    (0, _jquery2.default)('.added-to-betslip').removeClass('added-to-betslip');
    if (nextSelections.length) {
        nextSelections.forEach(function (selection) {
            var $priceElements = (0, _jquery2.default)('[data-diffusion-outcomers-id="' + selection.outcomersId + '"][data-diffusion-meeting-id="' + selection.meetingId + '"]');
            if ($priceElements.length) {
                $priceElements.addClass('added-to-betslip');
            }
        });
    }
}

function setDiffusionDataAttributes(element, priceConfig) {
    (0, _jquery2.default)(element).attr(_DIFFUSION2.default.DATA.OUTPUT.OUTCOMERS_ID, priceConfig.outcomersId || '').attr(_DIFFUSION2.default.DATA.OUTPUT.FRACTIONAL, priceConfig.fractionalPrice || '').attr(_DIFFUSION2.default.DATA.OUTPUT.DECIMAL, priceConfig.decimalPrice || '').attr(_DIFFUSION2.default.DATA.OUTPUT.HISTORY, priceConfig.historyPrice || '').attr(_DIFFUSION2.default.DATA.OUTPUT.STATUS, priceConfig.status || '').attr(_DIFFUSION2.default.DATA.OUTPUT.EVENT_ID, priceConfig.eventId || '').attr(_DIFFUSION2.default.DATA.OUTPUT.MARKET_ID, priceConfig.marketId || '').attr(_DIFFUSION2.default.DATA.OUTPUT.MEETING_ID, priceConfig.meetingId || '').attr(_DIFFUSION2.default.DATA.OUTPUT.NEXT_PRICE, priceConfig.nextPrice || '').attr(PRICE_BUTTON.POPUP.WIDTH, '').attr(PRICE_BUTTON.POPUP.HEIGHT, '').attr('href', '#');
}

function clearBookmakerStyling(element) {
    var $element = (0, _jquery2.default)(element);

    $element.addClass(PRICE_BUTTON.CLASSES.HIDDEN);
    Object.keys(PRICE_BUTTON.BOOKMAKERS).forEach(function (feed) {
        $element.removeClass(PRICE_BUTTON.BOOKMAKERS[feed]);
    });
}

function applyButtonStyling($priceElement, renderPriceValue, bookmaker) {
    $priceElement.removeClass(PRICE_BUTTON.POPUP.LINK_CLASS);
    if (renderPriceValue) {
        if (renderPriceValue === '-') {
            $priceElement.addClass(PRICE_BUTTON.CLASSES.NOT_CLICKABLE);
        } else {
            $priceElement.removeClass(PRICE_BUTTON.CLASSES.NOT_CLICKABLE);
        }
        $priceElement.removeClass(PRICE_BUTTON.CLASSES.HIDDEN).addClass(PRICE_BUTTON.BOOKMAKERS[bookmaker]);
    } else {
        $priceElement.addClass(PRICE_BUTTON.CLASSES.HIDDEN);
    }
}


//////////////////
// WEBPACK FOOTER
// ./~/rp-prices-component/lib/js/presenters/priceButtonPresenter.js
// module id = 2599
// module chunks = 0